export interface FilterFieldValue {
  display: string;
  value: string;
}

export enum FilterType {
  Text = 'text',
  Boolean = 'boolean',
  Date = 'date',
  Select = 'select',
  SelectLong = 'select-long'
}

export interface CollectionFilter {
  name: string;
  label: string;
  value: any;
  type: FilterType;
  fields?: FilterFieldValue[];
  conflicts?: string[];
}
